export const getCityErrorMessage = (intl, label) => {
  const cityMessageMap = {
    Area: intl.formatMessage({
      id: 'billing_address_form_errors.enter_area',
      defaultMessage: 'Please enter an area'
    }),
    City: intl.formatMessage({
      id: 'billing_address_form_errors.enter_city',
      defaultMessage: 'Please enter a city'
    }),
    'City/town': intl.formatMessage({
      id: 'billing_address_form_errors.enter_city_town',
      defaultMessage: 'Please enter a city/town'
    }),
    'City/ward/town/village': intl.formatMessage({
      id: 'billing_address_form_errors.enter_city_ward_town_village',
      defaultMessage: 'Please enter a city/ward/town/village'
    }),
    District: intl.formatMessage({
      id: 'billing_address_form_errors.enter_district',
      defaultMessage: 'Please enter a district'
    }),
    Suburb: intl.formatMessage({
      id: 'billing_address_form_errors.enter_suburb',
      defaultMessage: 'Please enter a suburb'
    }),
    Ward: intl.formatMessage({
      id: 'bkg.billing_address_form_errors.enter_ward',
      defaultMessage: 'Please enter a ward'
    })
  };

  return cityMessageMap[label] || cityMessageMap.City;
};

export const getPostalCodeErrorMessage = (intl, label) => {
  const postalCodeMessageMap = {
    'PIN code': intl.formatMessage({
      id: 'billing_address_form_errors.enter_valid_pin_code',
      defaultMessage: 'Please enter a valid PIN code'
    }),
    'Postal code': intl.formatMessage({
      id: 'billing_address_form_errors.enter_valid_postal_code',
      defaultMessage: 'Please enter a valid postal code'
    }),
    'ZIP code': intl.formatMessage({
      id: 'billing_address_form_errors.enter_valid_zip_code',
      defaultMessage: 'Please enter a valid zip code'
    })
  };

  return postalCodeMessageMap[label] || postalCodeMessageMap['Postal code'];
};

export const getZoneErrorMessage = (intl, label) => {
  const zoneMessageMap = {
    County: intl.formatMessage({
      id: 'billing_address_form_errors.select_county',
      defaultMessage: 'Please select a county'
    }),
    Emirate: intl.formatMessage({
      id: 'billing_address_form_errors.select_emirate',
      defaultMessage: 'Please select an emirate'
    }),
    Governorate: intl.formatMessage({
      id: 'billing_address_form_errors.select_governorate',
      defaultMessage: 'Please select a governorate'
    }),
    Prefecture: intl.formatMessage({
      id: 'billing_address_form_errors.select_prefecture',
      defaultMessage: 'Please select a prefecture'
    }),
    Province: intl.formatMessage({
      id: 'billing_address_form_errors.select_province',
      defaultMessage: 'Please select a province'
    }),
    Region: intl.formatMessage({
      id: 'billing_address_form_errors.select_region',
      defaultMessage: 'Please select a region'
    }),
    State: intl.formatMessage({
      id: 'billing_address_form_errors.select_state',
      defaultMessage: 'Please select a state'
    }),
    'State/territory': intl.formatMessage({
      id: 'billing_address_form_errors.state_territory',
      defaultMessage: 'Please select a state/territory'
    })
  };

  return zoneMessageMap[label] || zoneMessageMap.State;
};
